module.exports = __webpack_public_path__ + "img/ratings_state.6ff3b6ce.png";